import styled from '@emotion/styled';

import Box from '~/common/components/Box';

export const StyledLoan1003LayoutContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
`;
